<template>
    <BaseForm>
        <template #fields>
            <MultiLink
                :label="$t('extra-systems')"
                :links="values.extraSystems"
                :error-messages="errors.extraSystems"
                @input="setFieldValue('extraSystems', $event)"
                @delete="setFieldValue('extraSystems', $event)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { useMultiLink } from '@/components/MultiLink/composables/useMultiLink';
import MultiLink from '@/components/MultiLink/MultiLink.vue';
import { useEventInjection } from '@/event/composables/useEventInjection';
import { useForm } from '@/forms/composables/useForm';
import { computed } from 'vue';
import { EventSystemsSchema } from '../schemas';

const { event, createEventMultiLink } = useEventInjection();
const { getFormFieldLinks, saveMultiLinkFields } = useMultiLink(createEventMultiLink);

const extraSystemsId = computed(() => event.value?.extraSystems?.id);

const extraSystemsLinks = computed(() => event.value?.extraSystems?.links.nodes ?? []);

const { errors, values, setFieldValue, validate, onDiscard, resetForm } = useForm(
    EventSystemsSchema,
    computed(() => ({
        extraSystems: getFormFieldLinks(extraSystemsLinks),
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await saveMultiLinkFields([
            { id: extraSystemsId.value, fieldName: 'extraSystems', links: values.value.extraSystems },
        ]);
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
